import { render, staticRenderFns } from "./MilestoneTemplateDetailNewForm.vue?vue&type=template&id=5bdb4323&"
import script from "./MilestoneTemplateDetailNewForm.vue?vue&type=script&lang=js&"
export * from "./MilestoneTemplateDetailNewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports